import React, {Component} from 'react';
import './Home.css';
import me from './Me.jpg';

class Home extends Component {

    constructor(props) {

        super(props);
        this.state = {
            bio: undefined,
            attempts: 0
        };

    }

    componentDidMount(){

        if(this.state.bio === undefined)
            this.downloadBio();

    }

    render() {

        if(this.state.bio === undefined)
            return <div></div>;

        return (
            <div className="Home">
                <img src={me} alt="This is me" draggable="false" onContextMenu={
                    (e) =>{

                        e.preventDefault();
                        return false;
                    }
                }/>

                <p>{this.state.bio}</p>
            </div>
        );
    }

    downloadBio(){

        var caller = this;

        return fetch(process.env.PUBLIC_URL +'/bio.json')
            .then((response) => response.json())
            .then((responseJson) => {

                this.props.readyCallback(true);

                var text= responseJson['text'];
                caller.setState({bio: text});


            }).catch((error) => {

                if (caller.state.attempts < 3) {

                    caller.setState({
                        attempts: caller.state.attempts + 1
                    })

                    caller.downloadBio();

                }

                this.props.readyCallback(false, caller.state.attempts < 3);

            });

    }

}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js